import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=19bbfdb0&scoped=true&"
import script from "./Classify.vue?vue&type=script&lang=js&"
export * from "./Classify.vue?vue&type=script&lang=js&"
import style0 from "./Classify.vue?vue&type=style&index=0&id=19bbfdb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bbfdb0",
  null
  
)

export default component.exports